import { map } from 'rxjs/operators'
import { POST } from '../module/services/fetch'

export const applicationsByOuIdService = (ouCode: string) =>
  POST(`technical-users/application/find?ou=${ouCode}`).pipe(
    map((response: any) => response)
  )
